<template>
  <base-material-card
    color="primary"
    icon="mdi-file-compare"
    inline
    class="px-5 py-5"
  >
    <template v-slot:after-heading>
      <div class="display-1 font-weight-light">
        Adicionar Aderência BDGD
      </div>
    </template>

    <v-form class="pt-5">
      <v-row align="center" no-gutters class="mx-4">
        <v-col cols="12">
          <validation-provider v-slot="{ errors }" rules="required">
            <v-text-field
              id="titulo-aderencia-bdgd"
              label="Título"
              outlined
              :error-messages="errors"
              v-model="titulo"
            />
          </validation-provider>
        </v-col>
      </v-row>

      <v-row align="center" no-gutters class="mx-4">
        <v-col cols="12">
          <validation-provider v-slot="{ errors }" rules="required">
            <v-select
              id="tipo-aderencia-bdgd"
              no-gutters
              outlined
              :items="tipoBaseList"
              label="Tipo de Base"
              v-model="tipoBase"
              :error-messages="errors"
            />
          </validation-provider>
        </v-col>
      </v-row>

      <v-row align="center" justify="space-between" no-gutters class="mx-4 mb-3">
        <v-col 
          cols="12" sm="4" md="3" xl="1"
          v-for="(data, index) in datas" :key="index"
        >
          <v-menu
            v-model="menus[index]"
            :close-on-content-click="false"
            :nudge-right="100"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <validation-provider v-slot="{ errors }" rules="required|min:7">
                <v-text-field
                  :id="'date-picker-aderencia-bdgd-'+data.label.toLowerCase().replace(' ', '-')"
                  v-model="data.monthFormatted"
                  v-bind="attrs" v-on="on"
                  v-mask="'##/####'"
                  :label="data.label"
                  :error-messages="errors"
                  prepend-icon="mdi-calendar"
                  clearable
                  @blur="
                    data.month = parseMonth(data.monthFormatted);
                    updateValorData(data, data.month);
                  "
                />
              </validation-provider>
            </template>
            <v-date-picker
              v-model="data.month"
              type="month"
              :landscape="false"
              @input="
                updateValorData(data, data.month);
                data.monthFormatted = formatMonth(data.month);
                menus[index] = false;
              "
              locale="pt-br"
            />
          </v-menu>
        </v-col>
        <v-col cols="12" sm="3" md="3" lg="2">
          <v-checkbox 
            label="Incluir CHFUS COM" 
            v-model="incluirChfusCom" 
          />
        </v-col>
      </v-row>

      <v-row align="center" no-gutters class="mx-4">
        <v-col cols="12">
          <validation-provider v-slot="{ errors }" rules="required">
            <v-select
              id="tucs-aderencia-bdgd"
              :error-messages="errors"
              v-model="tucs"
              label="TUCs"
              :items="tucList"
              outlined
              chips
              small-chips
              multiple
              class="pb-0"
            />
          </validation-provider>
        </v-col>
      </v-row>
    </v-form>
  </base-material-card>
</template>

<script>

import TabelasService from '@/services/TabelasService'
import dayjs from 'dayjs';

export default {
  name: "ParametrosAderenciaBdgd",

  data() {
    return {
      titulo: "",
      tipoBase: "",
      tipoBaseList: ["Completa", "Blindada", "Incremental"],
      tucs: [],
      tucList: ["125", "135", "145", "160", "190", "210", "255", "265", "295", "325", "330", "340", "345", "395", "565", "570", "575", "580"],  
      datas: {
        dataAis: { label: "Data AIS", month: "", monthFormatted: "", valor: "" },
        dataBdgd: { label: "Data BDGD", month: "", monthFormatted: "", valor: "" },
      },
      menus: [false, false],
      incluirChfusCom: false,
    };
  },

  mounted() {
    this.getUltimaDataBase();
  },

  watch: {
    tipoBase(newValue) {
      if(newValue == "Completa") {
        this.tucs = this.tucList;
      } else {
        this.tucs = this.tucList.filter(tuc => !["190", "255"].includes(tuc));
      }
    }
  },

  methods: {
    getUltimaDataBase() {
      return TabelasService.getTabelaResumo()
        .then(response => {
          this.datas.dataAis.month = response.data.tabela_resumo.data_base_ais;
          this.datas.dataBdgd.month = response.data.tabela_resumo.data_base_bdgd;

          this.datas.dataAis.monthFormatted = this.formatMonth(this.datas.dataAis.month);
          this.datas.dataBdgd.monthFormatted = this.formatMonth(this.datas.dataBdgd.month);

          this.updateValorData(this.datas.dataAis, this.datas.dataAis.month);
          this.updateValorData(this.datas.dataBdgd, this.datas.dataBdgd.month);
        })
        .catch(err => {
          this.$toast.error("Erro ao tentar pegar última data base", "", { position: "topRight"});
          console.log("Erro:", err);
        });
    },

    updateValorData(data, valor) {
      (valor && valor.length <= 7) ? data.valor = valor + "-01" : data.valor = valor;
    },

    parseMonth(date) {
      if (!date) return null;

      const [month, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}`;
    },

    formatMonth(date) {
      return dayjs(date).format('MM/YYYY');
    },

    exportData() {
      return {
        nome: this.titulo,
        data_base_ais: this.datas.dataAis.valor,
        data_base_bdgd: this.datas.dataBdgd.valor,
        tucs: this.tucs,
        tipo_base: this.tipoBase,
        incluir_chfus_com: this.incluirChfusCom,
      }
    }
  }
};
</script>